import React from 'react';
import { Typewriter } from 'react-simple-typewriter';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Header.css';

const Header = () => {
    const words = ['traiteur asiatique Au Mirodélice', 'Bienvenue, Explorez, Dégustez'];

    return (
        <div className="app__header app__wrapper section__padding" id="home">
            <div className="app__wrapper_info pt-12">
                <SubHeading title="Chassez Une nouvelle saveur orientale" />
                <h1 className="app__header-h1">
                    <Typewriter
                        words={words}
                        loop={0} // Infinite loop
                        cursor
                        cursorStyle="_"
                        typeSpeed={70}
                        deleteSpeed={50}
                        delaySpeed={3000}
                    />
                </h1>
                <p className="p__opensans" style={{ margin: '2rem 0', color:'#595959', }}>
                    Découvrez une explosion de saveurs asiatiques authentiques. Laissez-vous emporter par une cuisine fraîche et colorée offrant de savoureux mélanges doux, sucrés-salés, préparé avec des ingrédients frais et de qualité.
                </p>
                <button type="button" className="custom__button"><a href="#menu"> Explorer le Menu</a></button>
            </div>

            <div className="app__wrapper_img">
                <img src={images.welcome} alt="header_img"  className="welcome-img"/>
                <img src={images.ellipse} alt="ellipse_img" className="ellipse-img" />
            </div>
        </div>
    );
};

export default Header;